import React, { useEffect, useState } from 'react'
//components
import ExampleContainer from './ExampleContainer'
import {
  BodyText,
  CaptionText,
  Divider,
  Row,
  PAYPAL_THEME,
  Link,
  Button,
} from '@paypalcorp/pp-react'

//syles
import styles from './AiSearch.module.css'
//config
import { mostPopular } from './config'
import Loading from './AiLoading'

const { sysColorBackgroundMediumContrast, sysColorSecondaryMain } = PAYPAL_THEME
interface LinkResultsSectionProps {
  handleSuggestionClick: (text: string) => void
  fetchResults: (text: string) => void
  fetchLinkResults: (text: string) => void
  isLoadingLinkResults: boolean
  linkResults: any
  errorStatus: string
  answerId: string
  searchID: string
  searchQuery: string
  setSearchQuery: (text: string) => void
  page: number
}
interface Entry {
  rank: number
  document_id: string
  document_title: string
  entry_template_id: string
  entry_template_name: string
  update_time: null
  language: string[]
  excerpt: string
  analytic_track?: string
  fields?: null
}
const LinkResultsSection = ({
  handleSuggestionClick,
  fetchResults,
  isLoadingLinkResults,
  linkResults = [],
  errorStatus,
  answerId,
  searchID,
  searchQuery,
  setSearchQuery,
  fetchLinkResults,
  page,
}: LinkResultsSectionProps) => {
  const fptiData = typeof window !== `undefined` && window.fpti
  // const observerTarget = useRef(null)
  const [isIntersecting, setIsIntersecting] = useState(false)
  const totalPages = 5

  useEffect(() => {
    if (isIntersecting) {
      fetchLinkResults(searchQuery)
      setIsIntersecting(false)
    }
  }, [searchQuery, isIntersecting])

  const handleSeeMore = () => {
    setIsIntersecting(true)
    if (fptiData) {
      const options = {
        data: {
          page: fptiData.page,
          pgrp: fptiData.pgrp,
          page_rank: page,
          tag: 'link-results-see-more',
          name: 'gen_ai_summary',
          link: 'link-results-see-more',
          event_name: 'link-results-see-more',
          answerid: answerId,
          component: 'devdiscoverynodeweb',
          searchID,
        },
      }

      if (window.PAYPAL?.analytics?.instance) {
        window.PAYPAL?.analytics?.instance?.recordClick(options)
      }
    }
  }

  const fetchAllResults = async (text: string) => {
    setSearchQuery(text)
    handleSuggestionClick(text)
    fetchResults(text)
  }
  const onLinkResultClick = (entry: Entry) => {
    const { document_id, document_title, rank } = entry
    if (fptiData) {
      const options = {
        data: {
          page: fptiData.page,
          pgrp: fptiData.pgrp,
          rank,
          tag: 'link-results',
          name: 'gen_ai_summary',
          link_name: document_title,
          link: document_id,
          answerid: answerId,
          firstPageResult: rank <= 5,
          component: 'devdiscoverynodeweb',
          searchID,
        },
      }

      if (window.PAYPAL?.analytics?.instance) {
        window.PAYPAL?.analytics?.instance?.recordClick(options)
      }
    }
  }
  return (
    <>
      {errorStatus && (
        <BodyText>
          There was an error. Please refresh the page and try again.
        </BodyText>
      )}
      {!isLoadingLinkResults && !linkResults.length && !errorStatus && (
        <ExampleContainer
          sectionData={mostPopular}
          handleClick={fetchAllResults}
          searchID={searchID}
        />
      )}
      {!isLoadingLinkResults && !errorStatus && linkResults.length > 0 && (
        <BodyText strong className={styles.p1}>
          All Results
        </BodyText>
      )}
      <div>
        {linkResults.map((entry) => (
          // {paginatedData.map((entry) => (
          <React.Fragment key={entry.id}>
            <Divider />
            <div className={styles.linkResultsContainer}>
              <Row>
                <Link
                  onClick={() => onLinkResultClick(entry)}
                  href={`${entry.document_id}?gen_ai_summary=true&search_id=${searchID}`}
                  target="_blank"
                >
                  <BodyText as="a" target="_blank" className={styles.pl1}>
                    {entry.document_title}
                  </BodyText>
                </Link>
                {/* Data for this feature is not send from API yet */}
                {/* <div className={styles.categoryBadge}>
                  <CaptionText>DOCS</CaptionText>
                </div> */}
              </Row>
              <Row>
                <CaptionText
                  clampAtLine={2}
                  style={{ color: sysColorBackgroundMediumContrast }}
                  className={`${styles.pt05} ${styles.pb0} ${styles.px1}`}
                >
                  {entry.excerpt}
                </CaptionText>
              </Row>
              {/* Data for this feature is not send from API yet */}
              {/* <Row className={`${styles.px1} ${styles.mb1}`}>
                <CaptionText strong style={{ color: sysColorSecondaryMain }}>
                  Docs
                </CaptionText>
                <ChevronRightIcon
                  size="xs"
                  style={{ color: sysColorSecondaryMain, marginTop: '.1rem' }}
                />

                <CaptionText strong style={{ color: sysColorSecondaryMain }}>
                  Beta
                </CaptionText>
              </Row> */}
            </div>
          </React.Fragment>
        ))}
      </div>
      {/* <div ref={observerTarget} /> */}
      {page <= totalPages && linkResults.length > 0 && (
        <div className={styles.buttonContainer}>
          <Button secondary onClick={handleSeeMore}>
            See more
          </Button>
        </div>
      )}
      {isLoadingLinkResults && !errorStatus && (
        <div>
          <Divider />
          <div className={styles.loadingContainer}>
            <Loading />
          </div>
          <Divider />
          <div className={styles.loadingContainer}>
            <Loading />
          </div>
          <Divider />
          <div className={styles.loadingContainer}>
            <Loading />
          </div>
          <Divider />
        </div>
      )}
      {/* <div>&nbsp;</div> */}
    </>
  )
}

export default LinkResultsSection
